import { render } from "./CX.vue?vue&type=template&id=70b027cb&scoped=true"
import script from "./CX.vue?vue&type=script&lang=js"
export * from "./CX.vue?vue&type=script&lang=js"

import "./CX.vue?vue&type=style&index=0&id=70b027cb&lang=scss&scoped=true"
import "./CX.vue?vue&type=style&index=1&id=70b027cb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b027cb"]])

export default __exports__